import { gql } from '@apollo/client'

import { AWARD_NODE_FRAGMENT } from '../fragments'

const SET_IS_CURATION_ENABLED_AWARD_MUTATION = gql`
  mutation setIsCurationEnabledAward($id: ID!, $isCurationEnabled: Boolean!) {
    setIsCurationEnabledAward(id: $id, isCurationEnabled: $isCurationEnabled) {
      ...AwardNodeFragment
    }
  }
  ${AWARD_NODE_FRAGMENT}
`

export default SET_IS_CURATION_ENABLED_AWARD_MUTATION
